import { t } from "@lingui/macro";
import React, { useState } from "react";

import { Button } from "@whoosh/design-system/src/components/controls";
import { Box, HStack } from "@whoosh/design-system/src/components/primitive";

import { EventCardPairings } from "../EventCardPairings/EventCardPairings";

export type EventCardNavigationProps = {
  onViewEvent?: () => void;
  eventSessionId?: string | null;
};

export const EventCardNavigation = ({
  onViewEvent,
  eventSessionId,
}: EventCardNavigationProps) => {
  const [showPairings, setShowPairings] = useState(false);

  return (
    <Box width="100%">
      <HStack gap={2} flexWrap="wrap" alignItems="center" paddingTop={4}>
        <Button
          style={{ flex: 1 }}
          variant="outline"
          size="tiny"
          label={t`View Event`}
          accessibilityLabel={t`View event details`}
          onPress={onViewEvent}
          testID="event-card-view-event-button"
        />
        <Button
          style={{ flex: 1 }}
          variant="secondary"
          size="tiny"
          label={showPairings ? t`Hide Event Pairings` : t`Show Event Pairings`}
          accessibilityLabel={
            showPairings ? t`Hide event pairings` : t`Show event pairings`
          }
          onPress={() => setShowPairings((prev) => !prev)}
          testID="event-card-pairings-toggle-button"
        />
      </HStack>
      {showPairings && eventSessionId ? (
        <EventCardPairings eventSessionId={eventSessionId} />
      ) : null}
    </Box>
  );
};
